<template>
    <div class="mobile" type="false">
        <headers_m></headers_m>
        <div class="mains">
            <img :src="$t('magenda').src" alt="" class="agenda">
        </div>
        <div class="footer_mobile">Copyright 2021 mi.com . All Rights Reserved. 京ICP备18018739号-1</div>
    </div>
</template>

<script>
    import headers_m from "../components/headers_m.vue"
    export default {
        components: {
            headers_m
        },
        name: 'agenda',
        data() {
            return {
                lang: ""
            }
        },
        created() {
            let lang = localStorage.getItem("lang");
            this.$i18n.locale = this.lang = lang;
        },
        mounted() {

        },
        methods: {}
    }
</script>
<style scoped>
.agenda{
    width: 100%;
    margin: 20px 0 0;
}
.mains {
    height: 93%;
    padding-bottom: 70px;
    box-sizing: border-box;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/agenda.vue